var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2229 0H2.98089C1.35032 0 0 1.32484 0 2.98089V13.0191C0 14.6497 1.32484 16 2.98089 16H21.2484C22.879 16 24.2293 14.6752 24.2293 13.0191V2.95541C24.2038 1.32484 22.879 0 21.2229 0ZM23.2611 12.9936C23.2611 14.1146 22.344 15.0064 21.2484 15.0064H2.98089C1.85987 15.0064 0.968153 14.0892 0.968153 12.9936V2.95541C0.968153 1.83439 1.88535 0.942675 2.98089 0.942675H21.2484C22.3694 0.942675 23.2611 1.85987 23.2611 2.95541V12.9936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.2294 3.74512H13.5032C13.2485 3.74512 13.0192 3.94894 13.0192 4.22919C13.0192 4.50945 13.223 4.71327 13.5032 4.71327H20.2294C20.4841 4.71327 20.7134 4.50945 20.7134 4.22919C20.7134 3.94894 20.5096 3.74512 20.2294 3.74512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.2294 7.49023H13.5032C13.2485 7.49023 13.0192 7.69406 13.0192 7.97431C13.0192 8.25457 13.223 8.45839 13.5032 8.45839H20.2294C20.4841 8.45839 20.7134 8.25457 20.7134 7.97431C20.7134 7.69406 20.5096 7.49023 20.2294 7.49023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.2294 11.2612H13.5032C13.2485 11.2612 13.0192 11.4651 13.0192 11.7453C13.0192 12.0001 13.223 12.2294 13.5032 12.2294H20.2294C20.4841 12.2294 20.7134 12.0256 20.7134 11.7453C20.7134 11.4651 20.5096 11.2612 20.2294 11.2612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.5095 7.46505C9.01905 7.03193 9.35026 6.36951 9.35026 5.65614C9.35026 4.33129 8.2802 3.26123 6.95536 3.26123C5.63052 3.26123 4.56045 4.33129 4.56045 5.65614C4.56045 6.39499 4.89166 7.03193 5.40122 7.46505C4.17829 8.10199 3.33752 9.45231 3.33752 11.0319C3.33752 11.4141 3.51587 12.102 4.61141 12.5606C5.24835 12.8154 6.06364 12.9682 6.95536 12.9682C8.76428 12.9682 10.5732 12.3822 10.5732 11.0574C10.5732 9.47779 9.73243 8.10199 8.5095 7.46505ZM5.52861 5.65614C5.52861 4.86633 6.16555 4.22938 6.95536 4.22938C7.74517 4.22938 8.38211 4.86633 8.38211 5.65614C8.38211 6.44594 7.74517 7.08289 6.95536 7.08289C6.16555 7.08289 5.52861 6.44594 5.52861 5.65614ZM6.95536 12.0001C5.50313 12.0001 4.30568 11.567 4.30568 11.0319C4.30568 9.37588 5.50313 8.02556 6.95536 8.02556C8.40759 8.02556 9.60504 9.37588 9.60504 11.0319C9.63052 11.567 8.40759 12.0001 6.95536 12.0001Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameicon);
export default __webpack_public_path__ + "static/media/nameicon.d2b68daa056d1c92c6d7037bf85c48a5.svg";
export { ForwardRef as ReactComponent };